import { render, staticRenderFns } from "./setting-wrapper.component.vue?vue&type=template&id=7f05d742&"
import script from "./setting-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./setting-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports